import CryptoJS from 'crypto-js';

export default class AESHelper {

    //WEB版本专用
    static AES_KEY_WEB = "VIX5XN2539vQ4SQI";
    static AES_IV_WEB = "MM1B4I6w23QhzHhG";

    //默认
    static AES_KEY_DEFAULT = "7BD2R3s8F2j833jo";
    static AES_IV_DEFAULT = "EzwHiu64Qh989496";

    //加密
    static EncryptWeb(str: string, iv: string = AESHelper.AES_IV_WEB): string {
        return AESHelper.encrypt(str, AESHelper.AES_KEY_WEB, iv);
    }

    // 解密
    static DecryptWeb(str: string, iv: string = AESHelper.AES_IV_WEB): string {
        return AESHelper.decrypt(str, AESHelper.AES_KEY_WEB, iv);
    }

    static DecryptDefault(str: string, iv: string = AESHelper.AES_IV_DEFAULT): string {
        return AESHelper.decrypt(str, AESHelper.AES_KEY_DEFAULT, iv);
    }

    private static encrypt(plaintext: string, keyStr: string, ivStr: string): string {
        const key = CryptoJS.enc.Utf8.parse(keyStr);// 确保32字节
        const iv = CryptoJS.enc.Utf8.parse(ivStr); // 确保16字节
        const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString(); // Base64格式
    }

    private static decrypt(ciphertext: string, keyStr: string, ivStr: string): string {
        const key = CryptoJS.enc.Utf8.parse(keyStr);// 确保32字节
        const iv = CryptoJS.enc.Utf8.parse(ivStr); // 确保16字节
        const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decrypted);
    }

    //动态创建IV
    public static GenerateIV(keyLength: number): string {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = '';
        for (let i = 0; i < keyLength; i++) {
            const rand = Math.floor(Math.random() * chars.length);
            result += chars.charAt(rand);
        }
        return result;
    }
}
